<!-- CONTAINER -->
<div class="container content-area relative">

  <!-- PAGE-HEADER -->
  <div class="page-header">
    <h4 class="page-title">Reports</h4>
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/admin/dashboard']">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Reports</li>
    </ol>
  </div>
  <!-- PAGE-HEADER END -->

  <!-- ROW-1 OPEN -->
  <div class="row" id="user-profile">
    <div class="col-lg-12">
      <div class="card">
        <div class="border-top">
          <div class="wideget-user-tab">
            <div class="tab-menu-heading">
              <div class="tabs-menu1">
                <ul ngbNav #nav="ngbNav" class="nav-tabs">
                  <li ngbNavItem>
                    <a ngbNavLink>Reports List</a>
                    <ng-template ngbNavContent>

                      <div class="row row-cols-1 row-cols-md-2 g-4 m-1">
                        <div class="col-md-4" *ngFor="let report of data">
                          <div class="card">
                            <img [src]=getSanitizeUrl(report.report_image) class="card-img-top"
                              alt="Hollywood Sign on The Hill" />
                            <div class="card-body">
                              <h5 class="card-title">{{report.reportname}}</h5>
                              <p class="card-text">
                                {{report.reportdescription}}
                                <small class="text-muted">
                                  <a [routerLink]="['/admin/reports/editreports/', report._id]"><i
                                      class="fa fa-edit"></i></a>
                                </small>
                              </p>
                            </div>
                          </div>
                        </div>



                      </div>

                    </ng-template>
                  </li>
                  <li ngbNavItem>
                    <a ngbNavLink>Add Report</a>
                    <ng-template ngbNavContent>
                      <br>
                      <div class="wideget-user-followers mb-0">
                        <app-add-edit-report></app-add-edit-report>
                      </div>
                    </ng-template>
                  </li>

                </ul>
                <div [ngbNavOutlet]="nav"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div><!-- COL-END -->
  </div>
  <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->